// IE 2026 11 04 / ODOO-350449 (заказ Игоря: форма ⚙ по наведению — в стиле вкладки Display)
// Раскладка формы быстрых настроек ⚙ грида (AttrGrid.commandPanel_topLeft — ряды команд set_viewParam) в вид вкладки Display (DisplayOptionsTab):
// группы с заголовком (Table / Rows / Performance), взаимоисключающие кнопки одного binding — одной сегментированной группой, одиночный
// переключатель (checkValue) — прежней кнопкой-тумблером (компонент команды, AttrButton), все тумблеры группы — одним рядом с переносом (kind 'toggles'),
// числовое поле (AttrNumber) — подпись слева, поле справа; прочее — как было (компонентом).
// IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой)
// Команды НЕ меняются: элементы раскладки держат ссылки на исходные объекты команд, клик отправляет ту же команду (gearForm_pickCommand → AttrGrid.gearForm_run),
// семантика — как у кнопки старой формы (клик по нажатой — снять: value = default). Выключатель fe.ux.gearFormStyle (по умолчанию вкл; выкл — прежний вид).
export const GEAR_FORM_FLAG = 'fe.ux.gearFormStyle'
export const GEAR_FORM_GROUPS = Object.freeze(['Table', 'Rows', 'Performance'])

// параметр viewParams → группа формы; неизвестный параметр (новая команда) — в группу предыдущего элемента
const PARAM_GROUP = Object.freeze({
    hideCHIPS: 'Table', showGridSummaryLine: 'Table', lightView: 'Table', headersVisibility: 'Table', slide_look: 'Table', allowSorting: 'Table',
    allowPinning: 'Table', showFilter: 'Table', showEmpty: 'Table', frozenColumns: 'Table', frozenRows: 'Table', use_delivery: 'Table',
    rowsHeight: 'Rows', collapseGroupsToLevel: 'Rows', hideEmptyRows: 'Rows', aggregateFooters: 'Rows', tree_lines_dotted: 'Rows',
    show_performance: 'Performance', use_customCellFactory: 'Performance', allow_formatItem: 'Performance',
    virtualizationThreshold_rows: 'Performance', virtualizationThreshold_cols: 'Performance',
})

export function gearForm_on(store) {
    try { return store?.setting?.(GEAR_FORM_FLAG, true) !== false } catch (e) { return true }
}

// подпись без разметки (<b>chips</b>) и без двоеточия в конце («Headers:» → «Headers»)
export function gearForm_plain(s, dropColon = false) {
    let out = String(s ?? '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim()
    if (dropColon) out = out.replace(/\s*:$/, '')
    return out
}

export function gearForm_param(cmd) {
    const b = String(cmd?.binding || '')
    if (!b.startsWith('doc.viewParams.')) return ''
    return b.split('.')[3] || ''
}

// параметры элемента для data-gf-param: без повторов (seg — один параметр, toggles — по кнопке)   // IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой)
export function gearForm_params(it) {
    return [...new Set((it?.cmds || []).map(gearForm_param).filter(Boolean))].join(' ')
}

const isLabel = (c) => c?.attr_type === 'AttrLabel'
const isToggle = (c) => !!c && !isLabel(c) && (!c.attr_type || c.attr_type === 'AttrButton') && c.checkValue !== undefined && !!c.binding
const isNumber = (c) => c?.attr_type === 'AttrNumber'

// rows — массив рядов команд (как commandPanel_topLeft) → [{ group, items: [{ kind: 'seg'|'toggles'|'num'|'other', key, label, cmds, help }] }]
// toggles — все одиночные переключатели группы одним элементом (на месте первого), cmds — команды по порядку; рисуются прежними кнопками   // IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой)
export function gearForm_layout(rows) {
    const byGroup = new Map()
    let cur = GEAR_FORM_GROUPS[0]
    const push = (it) => {
        const p = gearForm_param(it.cmds[0])
        cur = PARAM_GROUP[p] || cur
        if (!byGroup.has(cur)) byGroup.set(cur, [])
        byGroup.get(cur).push(it)
    }
    const helpOf = (c) => (c?.uiHelp ? { key: c.uiHelp, state: c.uiHelpState ?? null } : null)
    ;(Array.isArray(rows) ? rows : []).forEach((row, ri) => {
        const cmds = (Array.isArray(row) ? row : []).filter((c) => c && !c.hide)
        let i = 0
        while (i < cmds.length) {
            const c = cmds[i]
            const label = isLabel(c) ? c : null
            const j0 = label ? i + 1 : i
            const first = cmds[j0]
            // кнопки одного binding подряд (Headers: All | Column | Row; Sorting: Single | Multi; View: Light | Full) — одна группа
            let j = j0
            if (isToggle(first)) { while (j < cmds.length && isToggle(cmds[j]) && cmds[j].binding === first.binding) j++ }
            const run = cmds.slice(j0, j)
            if (run.length >= 2 || (label && run.length === 1)) {
                push({ kind: 'seg', key: `r${ri}-${i}`, label: label ? gearForm_plain(label.title, true) : '', cmds: run, help: helpOf(run[0]) })
                i = j
                continue
            }
            if (label) { push({ kind: 'other', key: `r${ri}-${i}`, label: '', cmds: [label], help: null }); i++; continue }
            if (isToggle(c)) push({ kind: 'bool', key: `r${ri}-${i}`, label: gearForm_plain(c.title), cmds: [c], help: helpOf(c) })   // свернётся в toggles ниже
            else if (isNumber(c)) push({ kind: 'num', key: `r${ri}-${i}`, label: gearForm_plain(c.title), cmds: [c], help: helpOf(c) })
            else push({ kind: 'other', key: `r${ri}-${i}`, label: '', cmds: [c], help: null })
            i++
        }
    })
    const order = [...GEAR_FORM_GROUPS, ...[...byGroup.keys()].filter((g) => !GEAR_FORM_GROUPS.includes(g))]
    return order.filter((g) => byGroup.has(g)).map((g) => ({ group: g, items: gearForm_foldToggles(g, byGroup.get(g)) }))
}

// IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой)
// одиночные переключатели группы → один элемент toggles на месте первого (кнопки в ряд с переносом), порядок команд сохраняется
function gearForm_foldToggles(group, items) {
    const out = []
    let tg = null
    for (const it of items) {
        if (it.kind !== 'bool') { out.push(it); continue }
        if (!tg) { tg = { kind: 'toggles', key: `tg-${group}`, label: '', cmds: [], help: null }; out.push(tg) }
        tg.cmds.push(...it.cmds)
    }
    return out
}

// пункты SegSwitch: seg — по кнопке на команду (ключ — индекс); пар Off | On больше нет — тумблеры рисуются прежними кнопками   // IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой)
export function gearForm_items(it) {
    if (it?.kind !== 'seg') return []
    return (it?.cmds || []).map((c, i) => ({ key: String(i), title: gearForm_plain(c.title), tip: gearForm_plain(c.tooltip), disabled: !!c.disabled }))
}

// выбранный пункт: seg — индекс нажатой кнопки (нет нажатой — null)   // IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой)
export function gearForm_value(it) {
    const i = (it?.cmds || []).findIndex((c) => !!c.active)
    return i >= 0 ? String(i) : null
}

// какую команду отправить по клику на пункт (null — ничего): seg — команду пункта (как клик по кнопке старой формы, в т.ч. по нажатой — снять);
// тумблеры отправляют команду сами (AttrButton.onClick)   // IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой)
export function gearForm_pickCommand(it, key) {
    if (!it || !Array.isArray(it.cmds)) return null
    if (it.kind === 'seg') {
        const c = it.cmds[Number(key)]
        return c && !c.disabled ? c : null
    }
    return null
}
